export function formatarTelefone(telefone: string) {
	let telefoneFormatado = telefone.replace(/\D/g, '')
	// Coloca parênteses em volta dos dois primeiros dígitos
	telefoneFormatado = telefoneFormatado.replace(/^(\d\d)(\d)/g, '($1) $2')
	if (telefone.length >= 11)
		// Coloca hífen entre o quinto e o sexto dígitos
		telefoneFormatado = telefoneFormatado.replace(/(\d{5})(\d)/, '$1-$2')
	else
		// Coloca hífen entre o quarto e o quinto dígitos
		telefoneFormatado = telefoneFormatado.replace(/(\d{4})(\d)/, '$1-$2')
	return telefoneFormatado
}

export function formatarData(data: string) {
	const [ ano, mes, dia] = data.split('T')[0].split('-')
	return [dia, mes, ano].join('/')
}
